import { useQuery } from '@tanstack/react-query';

import { getBestDealsAisle } from 'api/jalapeno';
import { DUPLICATE_ITEMS_AISLE_IDS } from 'constants/shop';

import useAccountQuery from './useAccountQuery';

export const BEST_DEALS_AISLE_QUERY_KEY = 'best-deals-aisle';

const useBestDealsAisleQuery = ({ queryProps } = {}) => {
    const { data: account } = useAccountQuery();
    const { chargeID } = account?.nextOrder ?? {};

    return useQuery({
        queryKey: [BEST_DEALS_AISLE_QUERY_KEY, chargeID],
        queryFn: async () => {
            const response = await getBestDealsAisle(chargeID);
            if (response.data.aisles) {
                response.data.aisles = response.data.aisles?.filter(
                    (aisle) => !DUPLICATE_ITEMS_AISLE_IDS.includes(aisle.id)
                );
            }
            return response?.data;
        },
        enabled: !!chargeID,
        ...queryProps,
    });
};

export default useBestDealsAisleQuery;
